document.addEventListener("DOMContentLoaded", function () {

  const diameters = {
    Galvanised: ["1","1.2","1.5","2","2.5","3","4","5","6","7","8","10"],
    Stainless: ["0.54","0.68","0.75","0.81","1","1.25","1.5","1.8","2","2.5","3","4","5","6","8","10","12"]
  };

  const wire = document.getElementById("wireMaterial");
  if (!wire) return; // stops errors if section not on page

  const ferrule = document.getElementById("ferruleMaterial");
  const diameter = document.getElementById("diameter");
  const tool = document.getElementById("tool");
  const result = document.getElementById("result");

  function updateFerrules() {
    ferrule.innerHTML = "";
    if (wire.value === "Galvanised") {
      ferrule.add(new Option("Aluminium", "Aluminium"));
    } else {
      ferrule.add(new Option("Stainless Steel", "Stainless"));
      ferrule.add(new Option("Copper", "Copper"));
    }
  }

  function updateDiameters() {
    diameter.innerHTML = "";
    diameters[wire.value].forEach(size => {
      diameter.add(new Option(size + " mm", size));
    });
  }

  function calculate() {
    const d = parseFloat(diameter.value);
    const small = d <= 2.5;

    if (wire.value === "Stainless" && ferrule.value === "Stainless" && tool.value === "Hand") {
      result.value = "Use a Hydraulic Press";
    } else {
      result.value = tool.value === "Hydraulic"
        ? "Size + 1"
        : (small ? "Size for Size" : "Size + 1");
    }
  }

  wire.addEventListener("change", () => {
    updateFerrules();
    updateDiameters();
    calculate();
  });

  ferrule.addEventListener("change", calculate);
  diameter.addEventListener("change", calculate);
  tool.addEventListener("change", calculate);

  updateFerrules();
  updateDiameters();
  calculate();

});
